/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const deletionModeDescriptorSchema = z.object({
  includeDeleted: z.boolean().nullish(),
  kind: z.enum(['SET_DIFFERENCE', 'FEED', 'NONE', 'UNSPECIFIED']),
  scope: z.enum(['FILTER', 'CONTAINER']).nullish(),
});
